<template>
    <b-container fluid>
        <b-card>
            <modal name="edit-user" @before-close="editModalClosed" width="60%" height="auto" :scrollable="true" :adaptive="true">
                <UserForm :edit-mode="true" :user="this.currentUser" :title="$t('posUser.edit-title')"></UserForm>
            </modal>
            <b-card-body>
                <b-row style="padding-bottom: 10px;">
<!--                    <b-col cols="8" align-h="start" class="pull-left">-->
<!--                        <button type="button" @click="toggleFilter" class="btn btn-fill btn-info">{{ $t('filter.filter') }}</button>-->
<!--                    </b-col>-->
                    <b-col cols="4" align-h="end" class="pull-right">
                        <input type="search" class="form-control input-sm" :placeholder="$t('userList.search-placeholder')" v-model="searchQuery" aria-controls="datatables">
                    </b-col>
                </b-row>
                <b-row>
                    <el-table class="table-striped"
                              v-if="queriedData"
                              :data="queriedData"
                              @sort-change = "sortChange"
                              border
                              style="width: 100%"
                              ref="table">
                        <el-table-column
                                v-for="column in tableColumns"
                                :key="column.label"
                                :min-width="column.minWidth"
                                :prop="column.prop"
                                :label="column.label"
                                :formatter="column.formatter"
                                :sortable="column.sortable">
                        </el-table-column>
                        <el-table-column
                                :key="$t('userList.scan-qr-upn')"
                                min-width="40"
                                :label="$t('userList.scan-qr-upn')">
                            <template slot-scope="props">
                                <i v-if="props.row.scanQrUpnEnabled === true" class="ti-check-box"></i>
                                <i v-if="props.row.scanQrUpnEnabled === false" class="ti-close"></i>
                            </template>
                        </el-table-column>
                        <el-table-column
                                :key="$t('userList.manual-qr-upn')"
                                min-width="40"
                                :label="$t('userList.manual-qr-upn')">
                            <template slot-scope="props">
                                <i v-if="props.row.manualQrUpnEnabled === true" class="ti-check-box"></i>
                                <i v-if="props.row.manualQrUpnEnabled === false" class="ti-close"></i>
                            </template>
                        </el-table-column>
                        <el-table-column :min-width="60">
                            <template slot-scope="props">
                                <a :title="$t('userList.delete-user')"  class="btn btn-simple btn-lg btn-icon" @click="deletePopup(props.row)"><i class="ti-trash"></i></a>
                                <a :title="$t('userList.edit-user')" class="btn btn-simple btn-lg btn-icon info"  @click="editUser(props.row)"><i class="ti-pencil"></i></a>
                            </template>
                        </el-table-column>
                    </el-table>
                </b-row>
                <b-row style="padding-top: 10px;">
                    <b-col md="auto">
                        <el-select
                                style="width: 80px; margin-left: 20px;"
                                class="select-default"
                                v-model="pagination.perPage"
                                placeholder="Per page">
                            <el-option
                                    class="select-default"
                                    v-for="item in pagination.perPageOptions"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                            </el-option>
                        </el-select>
                    </b-col>
                    <b-col>
                        <b-button type="button" @click="search" class="btn btn-info">
                            {{ $t('userList.refresh') }}
                        </b-button>
                    </b-col>
                    <b-col>
                        <p-pagination class="pull-right"
                                      v-model="pagination.currentPage"
                                      :per-page="pagination.perPage"
                                      :total="pagination.total">
                        </p-pagination>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </b-container>
</template>

<script>
    import Vue from 'vue'
    import {filter} from '../data/usersFilter'
    import utils from "../util/utils";
    import {Select, Option, Table, TableColumn} from "element-ui";
    import PPagination from 'frontend_common/src/components/UIComponents/Pagination.vue';
    import Constants from "frontend_common/src/constants/globalConstants";
    import moment from "moment";
    import swal from 'sweetalert2'
    import UserForm from "./UserForm";

    Vue.use(Table);
    Vue.use(TableColumn);

    export default {
        name: "List",
        components: {
            [Select.name]: Select,
            [Option.name]: Option,
            PPagination,
            UserForm
        },
        data() {
            return {
                searchQuery: '',
                userData: null,
                currentUser: null,
                tableColumns: [
                    {
                        prop: 'taxNumber',
                        label: this.$t('userList.tax-number'),
                        sortable: 'custom'
                    },
                    {
                        prop: 'name',
                        label: this.$t('userList.name'),
                        sortable: 'custom'
                    },
                    {
                        prop: 'cashDepositIban',
                        label: this.$t('userList.cash-deposit-iban'),
                        sortable: 'custom'
                    },
                    {
                        prop: 'birthTime',
                        label: this.$t('userList.birth-time'),
                        sortable: 'custom',
                        formatter: this.birthDateFormatter
                    },
                    {
                        prop: 'lastUpdate',
                        label: this.$t('userList.last-update-time'),
                        sortable: 'custom',
                        formatter: this.lastUpdateTimeFormatter
                    },
                ],
                pagination: {
                    perPage: this.$store.getters.getPerPage,
                    currentPage: 1,
                    perPageOptions: [10, 25, 50],
                    total: 0
                },
                propsToSearch:  ['taxNumber', 'name', 'cashDepositIban'],
                tableData: [],
                sort: {prop: 'birthTime', order: 'descending'},
            }
        },
        methods: {
            search() {
                let query = JSON.parse(JSON.stringify(filter));

                this.$store.dispatch('userQuery', query)
                    .then((response) => {
                        this.tableData = response.data;
                    })
                    .catch(error => {
                        this.$store.commit('setError', error);
                    });
            },
            sortChange(column) {
                if (column.prop)
                    this.sort = {prop: column.prop, order: column.order}
                else
                    this.sort = null;
            },
            dynamicSort(property) {
                let sortOrder = 1;
                if(property[0] === "-") {
                    sortOrder = -1;
                    property = property.substr(1);
                }

                return function (a,b) {
                    let valueA;
                    let valueB;

                    let propertyA = utils.methods.getProperty(property, a);
                    let propertyB = utils.methods.getProperty(property, b);
                    if (propertyA === null || typeof propertyA === 'undefined') propertyA = "";
                    if (propertyB === null || typeof propertyB === 'undefined') propertyB = "";
                    valueA = propertyA.toString().toUpperCase();
                    valueB = propertyB.toString().toUpperCase();


                    if(sortOrder === -1) {
                        return ((valueA == valueB) ? 0 : ((valueA < valueB) ? 1 : -1));
                    } else {
                        return ((valueA == valueB) ? 0 : ((valueA > valueB) ? 1 : -1));
                    }
                }
            },
            birthDateFormatter: function(row) {
                return moment(row.birthTime).format(Constants.DATE_FORMAT);
            },
            lastUpdateTimeFormatter: function(row) {
                return moment(row.lastUpdate).format(Constants.DATE_FORMAT);
            },
            deletePopup(userData) {
                this.userData = userData;
                swal.fire({
                    title: this.$t('userList.delete-notification'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: this.$t('userList.delete'),
                    cancelButtonText: this.$t('userList.cancel'),
                    confirmButtonClass: 'btn btn-danger btn-fill',
                    cancelButtonClass: 'btn btn-success btn-fill',
                    buttonsStyling: false
                }).then((result) => {
                    if (result.value) {
                        this.deleteUser(this.userData);
                    } else {
                        this.userData = null;
                    }
                })
            },
            deleteUser(userData) {
                let request = {
                    user: userData
                };

                this.$store.dispatch('deleteUser', request)
                    .then(() => {
                        this.userData = null;
                        swal.fire({
                            title: this.$t('userList.delete-title'),
                            text: this.$t('userList.delete-success'),
                            confirmButtonClass: 'btn btn-success btn-fill',
                            icon: 'success'
                        }).then(() => {
                            this.search();
                        })
                    })
                    .catch(error => {
                        this.userData = null;
                        this.$store.commit('setError', error);
                    });
            },
            editUser(userData) {
                // alert('Update user: ' + JSON.stringify(userData));
                this.currentUser = JSON.parse(JSON.stringify(userData));
                this.$modal.show('edit-user');
            },
            editModalClosed(event) {
                if(typeof(event) !== 'undefined' && typeof(event.params) !== 'undefined' && typeof(event.params.updated) !== 'undefined' && event.params.updated) {
                    this.search();
                }
            },
        },
        computed: {
            users() {
                return this.$store.getters.getUsers;
            },
            pagedData () {
                let sorted = this.tableData.slice(0);
                if (this.sort){
                    const direction = this.sort.order === "ascending" ? "" : "-";
                    sorted.sort(this.dynamicSort(`${direction}${this.sort.prop}`))
                }
                // return sorted;
                return sorted.slice(this.from, this.to)
            },
            queriedData () {
                if (!this.searchQuery) {
                    this.pagination.total = this.tableData.length
                    return this.pagedData
                }

                let sorted = this.tableData.slice(0);
                if (this.sort){
                    const direction = this.sort.order === "ascending" ? "" : "-";
                    sorted.sort(this.dynamicSort(`${direction}${this.sort.prop}`))
                }

                let result = sorted
                    .filter((row) => {
                        let isIncluded = false
                        for (let key of this.propsToSearch) {
                            // let rowValue = row[key].toString()
                            if (row[key] !== null && typeof(row[key]) !== 'undefined' && row[key].includes && row[key].includes(this.searchQuery)) {
                                isIncluded = true
                            }
                        }
                        return isIncluded
                    })
                this.pagination.total = result.length
                return result.slice(this.from, this.to)
            },
            to () {
                let highBound = this.from + this.pagination.perPage
                if (this.total < highBound) {
                    highBound = this.total
                }
                return highBound
            },
            from () {
                return this.pagination.perPage * (this.pagination.currentPage - 1)
            },
            total () {
                this.pagination.total = this.tableData.length
                return this.tableData.length
            }
        },
        mounted () {
            this.search();
        },
    }
</script>

<style scoped>

</style>